<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>运营商销售明细</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.jigouquerymode" placeholder="" class="select2">
              <el-option label="查询自己" value="1"></el-option>
              <el-option label="查询自己+所有下级" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.begintime" type="date" placeholder="选择开始日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker v-model="keywords.endtime" type="date" placeholder="选择结束日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.bomsn" placeholder="请选择产品" class="select2">
              <!-- <el-option label="请选择产品" value=""></el-option> -->
              <el-option
                v-for="item in optionsproduct" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="primary" @click="clickShowMore">{{showMoreName}}</el-button>
            <el-button type="primary" @click="clickexcel">导出Excel</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataListMix" :row-class-name="tableRowClassName" border stripe>
          <el-table-column prop="Productname" label="产品名称" min-width="4%"></el-table-column>
          <el-table-column prop="Jigouname1" label="一级运营商名称" min-width="6%" v-if="showMore"></el-table-column>
          <el-table-column prop="Jigouname2" label="二级运营商名称" min-width="6%" v-if="showMore"></el-table-column>
          <el-table-column prop="Jigouname3" label="三级运营商名称" min-width="6%" v-if="showMore"></el-table-column>
          <el-table-column prop="Jigouname" label="运营商名称" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="发货日期" min-width="6%"></el-table-column>
          <el-table-column prop="Invoicestatuss" label="开票状态" min-width="4%"></el-table-column>
          <el-table-column prop="Num" min-width="4%">
            <template slot="header">
              <span @click="clicknum">发货数量</span>
            </template>
          </el-table-column>
          <el-table-column prop="Money" min-width="4%">
            <template slot="header">
              <span @click="clickmoney">售价</span>
            </template>
          </el-table-column>
          <el-table-column prop="Moneytotal" min-width="4%">
            <template slot="header">
              <span @click="clickmoneytotal">金额</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
  <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>

      </el-tab-pane>
      <!-- 清单列表 end -->
  </el-tabs>
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou
  },
  name: 'MyDetailYunyingshangSales',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      // 查询
      keywords: {
        jigouquerymode: '2',
        jigouid: '-1',
        jigouname: '',
        bomsn: '',
        begintime: '',
        endtime: ''
      },
      dataList: [],
      dataListnum: 0,
      dataListMix: [],
      selectedPageNo: 1,
      TotalNum: 0,
      TotalMoneytotal: 0,
      sortdinggou: false,
      sortxiaoshou: false,
      sortkucun: false,
      showMore: true,
      showMoreName: '收缩'
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
  },
  methods: {
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'firstline'
      }
      return ''
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetYunYingShangSalesDetail()
    },
    clickShowMore () {
      this.showMore = !this.showMore
      if (this.showMore) {
        this.showMoreName = '收缩'
      } else {
        this.showMoreName = '展开'
      }
    },
    clickexcel () {
      this.apiGetYunYingShangSalesDetailExcel()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetYunYingShangSalesDetail()
    },
    clicknum () {
      var that = this
      that.sortdinggou = !that.sortdinggou
      that.dataList.sort(function (a, b) {
        var x = a.Num
        var y = b.Num
        if (that.sortdinggou) {
          x = b.Num
          y = a.Num
        }
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      this.getdataListMix()
    },
    clickmoney () {
      var that = this
      that.sortxiaoshou = !that.sortxiaoshou
      that.dataList.sort(function (a, b) {
        var x = a.Money
        var y = b.Money
        if (that.sortxiaoshou) {
          x = b.Money
          y = a.Money
        }
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      this.getdataListMix()
    },
    clickmoneytotal () {
      var that = this
      that.sortkucun = !that.sortkucun
      that.dataList.sort(function (a, b) {
        var x = a.Moneytotal
        var y = b.Moneytotal
        if (that.sortkucun) {
          x = b.Moneytotal
          y = a.Moneytotal
        }
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      this.getdataListMix()
    },
    getdataListMix () {
      this.dataListMix = []
      this.dataListMix.push({
        Jigouid: 0,
        Jigouname: '',
        Bomsn: '',
        Productname: '合计',
        Createtime: '',
        Num: this.TotalNum,
        Money: '',
        Moneytotal: this.TotalMoneytotal
      })
      this.dataListMix.push.apply(this.dataListMix, this.dataList)
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        querytype: 1
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.optionsproduct = []
            var bomsnall = ''
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype === 1) {
                that.optionsproduct.push({ value: item1.Bomsn, label: item1.Name })
                if (bomsnall.length > 0) {
                  bomsnall = bomsnall + ';' + item1.Bomsn
                } else {
                  bomsnall = item1.Bomsn
                }
              }
            })
            that.optionsproduct.push({ value: bomsnall, label: '所有产品' })
            that.keywords.bomsn = bomsnall
            that.apiGetYunYingShangSalesDetail()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetYunYingShangSalesDetail: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouquerymode: that.keywords.jigouquerymode,
        bomsn: that.keywords.bomsn,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      that.dataList = []
      that.dataListMix = []
      that.TotalNum = 0
      that.TotalMoneytotal = 0
      axios.post(Vue.prototype.global.Url_GetYunYingShangSalesDetail, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.dataListnum = response.data.Listnum
            that.TotalNum = response.data.TotalNum
            that.TotalMoneytotal = response.data.TotalMoneytotal
            that.getdataListMix()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetYunYingShangSalesDetailExcel: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouquerymode: that.keywords.jigouquerymode,
        bomsn: that.keywords.bomsn,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetYunYingShangSalesDetailExcel, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
